//
//
//
//
//
//
//
//
//

import uuidMixin from '../../mixins/uuid'

export default {
  name: 'agree',
  mixins: [uuidMixin],
  props: {
    value: Boolean
  },
  created () {
    this.currentValue = this.value
  },
  data () {
    return {
      currentValue: false
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (val) {
      this.$emit('input', val)
    }
  }
}
